export function normalizeUrl(url: string, base = window.location.origin) {
  if (!url.startsWith('/') && !url.startsWith('http')) {
    url = '/' + url; // Ensure relative URLs start with "/"
  }

  try {
    return new URL(url, base);
  } catch (error) {
    console.error(`Invalid URL: ${url}`, error);
    return null;
  }
}
